module.exports = __webpack_public_path__ + "static/media/energy-smart-video.36c4eb78.webp";